<template>
  <a href="#" @click="onReturnYourself" v-if="isImpersonating">
    <b-badge pill class="badge-impersonate">
      Back to yourself
    </b-badge>
  </a>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'ImpersonateBadge',
  computed: {
    ...mapGetters('impersonate', [
      'isImpersonating',
    ]),
    ...mapGetters('auth', [
      'hasPerm',
    ]),
  },
  methods: {
    ...mapActions('impersonate', [
      'returnYourself',
    ]),
    onReturnYourself() {
      this.returnYourself()
      window.location.reload()
    }
  }
}
</script>